// extracted by mini-css-extract-plugin
module.exports = {"buttons":"NavButtons_buttons__EjChc","back":"NavButtons_back__2CGtX"};